import { useEffect, useState } from "react";
import { OrderTable } from "../../components/admin/OrderTable";
import type { OrderWithItems, OrderStatus } from "../../types";
import { usePageTitle } from "../../hooks/usePageTitle";

export function Orders() {
  usePageTitle("Manage Orders");
  const [orders, setOrders] = useState<OrderWithItems[]>([]);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const response = await fetch("/api/admin/orders");
      if (response.ok) {
        const data = await response.json();
        setOrders(data);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const handleStatusUpdate = async (id: number, status: OrderStatus) => {
    try {
      const response = await fetch(`/api/admin/orders/${id}/status`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status }),
      });

      if (response.ok) {
        await fetchOrders();
      }
    } catch (error) {
      console.error("Error updating order status:", error);
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-bold mb-8">Orders</h1>

      <div className="bg-white rounded-lg shadow">
        <OrderTable orders={orders} onStatusUpdate={handleStatusUpdate} />
      </div>
    </div>
  );
}
